import { Link } from "react-router-dom";
import Icon from "../../components/Icon";
import LoadingBlock from "../../components/LoadingBlock";
import { useApi } from "../../hooks/useApi";
import { getOverview } from "../../api/superAdminService";
import { formatDate } from "../../utils/formatters";

const inr = (n) => "₹" + Math.round(Number(n || 0)).toLocaleString("en-IN");

export default function OverviewPage() {
  const overview = useApi(() => getOverview());
  const d = overview.data?.data;

  return (
    <>
      <div className="page-head">
        <div>
          <h1 className="page-title">Platform Overview</h1>
          <div className="page-sub">All firms, subscriptions, and revenue at a glance</div>
        </div>
      </div>

      {overview.loading || !d ? (
        <LoadingBlock rows={6} />
      ) : (
        <>
          <div className="kpi-grid">
            <div className="kpi">
              <div className="kpi-label"><Icon name="building" size={12} /> Firms</div>
              <div className="kpi-value">{d.firms.total}<small>{d.firms.active} active · {d.firms.suspended} suspended</small></div>
            </div>
            <div className="kpi">
              <div className="kpi-label"><Icon name="user" size={12} /> Paid seats</div>
              <div className="kpi-value">{d.subscriptions.total_seats}<small>{d.users.total} platform users</small></div>
            </div>
            <div className="kpi">
              <div className="kpi-label"><Icon name="receipt" size={12} /> Expected / year</div>
              <div className="kpi-value">{inr(d.subscriptions.expected_yearly_revenue)}<small>collected YTD {inr(d.revenue.collected_ytd)}</small></div>
            </div>
            <div className="kpi">
              <div className="kpi-label" style={{ color: "var(--purple)" }}><Icon name="clock" size={12} /> Trials</div>
              <div className="kpi-value">{d.subscriptions.trials}<small>active trial account{d.subscriptions.trials === 1 ? "" : "s"}</small></div>
            </div>
            <div className="kpi">
              <div className="kpi-label" style={{ color: "var(--warning)" }}><Icon name="clock" size={12} /> Attention</div>
              <div className="kpi-value">{d.subscriptions.in_grace + d.subscriptions.expiring_30d}<small>{d.subscriptions.in_grace} in grace · {d.subscriptions.expiring_30d} expiring 30d</small></div>
            </div>
          </div>

          <div className="card" style={{ marginTop: 16 }}>
            <div className="card-head">
              <div>
                <div className="card-title">Expiring within 30 days</div>
                <div className="card-sub">Renewals to chase before access lapses</div>
              </div>
            </div>
            <div className="card-body no-pad">
              {d.expiring_soon.length === 0 ? (
                <div className="empty-state">
                  <div className="empty-state-title">Nothing due in the next 30 days.</div>
                </div>
              ) : (
                <table className="table">
                  <thead>
                    <tr><th>Firm</th><th className="t-num">Seats</th><th className="t-num">Yearly amount</th><th>Due</th></tr>
                  </thead>
                  <tbody>
                    {d.expiring_soon.map((s) => (
                      <tr key={s.id}>
                        <td><Link className="t-primary" to={`/super/firms/${s.firm_id}`}>{s.firm?.name}</Link></td>
                        <td className="t-num">{s.seats}</td>
                        <td className="t-num">{inr(s.yearly_amount)}</td>
                        <td className="t-muted">{formatDate(s.period_end)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          <div className="card" style={{ marginTop: 16 }}>
            <div className="card-head">
              <div>
                <div className="card-title">Active trials</div>
                <div className="card-sub">Trial accounts to convert before they expire</div>
              </div>
            </div>
            <div className="card-body no-pad">
              {(d.trials_active || []).length === 0 ? (
                <div className="empty-state">
                  <div className="empty-state-title">No active trial accounts.</div>
                </div>
              ) : (
                <table className="table">
                  <thead>
                    <tr><th>Firm</th><th className="t-num">Seats</th><th>Trial ends</th></tr>
                  </thead>
                  <tbody>
                    {d.trials_active.map((s) => (
                      <tr key={s.id}>
                        <td>
                          <Link className="t-primary" to={`/super/firms/${s.firm_id}`}>{s.firm?.name}</Link>
                          <span className="badge badge-purple" style={{ marginLeft: 6 }}>Trial</span>
                        </td>
                        <td className="t-num">{s.seats}</td>
                        <td className="t-muted">{formatDate(s.period_end)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
}
